export default __webpack_public_path__ + "locales/lv/ChangePortalOwner.json?hash=cee2f0b7f35f703be8e69f144c76bb24";